/**
 * The function generates a random number between a given minimum and maximum value.
 * @param min - The minimum value that the random number can be.
 * @param max - The maximum value that the random number can be.
 * @returns a random integer between the minimum and maximum values provided as arguments.
 */
export default function generateRandomNumber(min, max) {
  const random = Math.random();
  return Math.floor(random * (max - min + 1)) + min;
}
